// Turkish translation. Keep keys in the same order as en.ts so a diff
// of the two files is meaningful when adding new strings.

import type { Translations } from "../i18n";

const tr: Translations = {
  nav: {
    home: "Ana sayfa",
    how_it_works: "Nasıl çalışır",
    strategy_lab: "Strateji Lab",
    tokens: "Sinyal geçmişi",
    open_telegram: "Telegram'da aç →",
    follow_x: "X'te takip et",
    toggle_menu: "Menüyü aç/kapa",
  },
  footer: {
    tagline: "Base, Ethereum, Solana, Robinhood, BNB Chain & Arc için geliştirildi.",
  },

  landing: {
    live_badge: "Base, Ethereum, Solana, Robinhood, BNB & Arc'ta canlı",
    hero_title_lead: "Akıllı cüzdanları",
    hero_title_accent: "otomatik",
    hero_title_tail: "kopyala",
    hero_sub:
      "Kanıtlanmış trader'lar bir tokeni aldığı an Telegram'a anlık uyarı. İstersen seçtiğin pozisyon büyüklüğüyle otomatik işlem. Her gün backtest edilir.",
    cta_start: "Telegram'da başla →",
    cta_open_lab: "Strateji Lab'ı aç",

    stat_signals: "Sinyaller (30g)",
    stat_strategies: "Test edilen strateji",
    stat_chains: "Zincir",
    stat_monitoring: "İzleme",
    stat_monitoring_value: "7/24",

    features_title: "Grafiklerle uğraşmak istemeyen trader'lar için",
    features_sub:
      "AlphaHedge kazananları bulduğunu kanıtlamış cüzdanları izler. Sinyali fiyat hareket etmeden önce alırsın.",
    feature_smart_title: "Akıllı cüzdan tespiti",
    feature_smart_body:
      "100+ seçilmiş cüzdan gerçek zamanlı izleniyor. Aynı tokeni en az 3'ü aldığında anında uyarı geliyor.",
    feature_auto_title: "İsteğe bağlı otomatik işlem",
    feature_auto_body:
      "Bir tıkla bot her doğrulanmış sinyalde senin yerine işlem yapar: senin büyüklüğün, slippage'ın, stop'un.",
    feature_filters_title: "Seni koruyan filtreler",
    feature_filters_body:
      "Market cap tabanı, minimum likidite, token yaş limiti... her sinyal senin risk profiline göre süzülür.",
    feature_discover_title: "Neyin işe yaradığını keşfet",
    feature_discover_body:
      "Günlük otomatik keşif son 30 günün sinyallerini analiz eder ve en kârlı filtre kombinasyonlarını çıkarır.",
    feature_multichain_title: "Çoklu zincir",
    feature_multichain_body:
      "Base, Ethereum, Solana, Robinhood, BNB Chain ve Arc kutudan çıktığı gibi destekleniyor. Tek bot, tüm ekosistemler, tek panel.",
    feature_telegram_title: "Telegram tabanlı",
    feature_telegram_body:
      "Yüklenecek uygulama yok, güvenmen gereken eklenti yok. Zaten gün boyu açık olan sohbeti kullan.",

    how_title: "Nasıl çalışır",
    how_sub: "Üç adım, tamamen otomatik.",
    how_step1_title: "Cüzdanları izleriz",
    how_step1_body:
      "Sistemimiz Base, Ethereum, Solana, Robinhood, BNB Chain ve Arc'taki 100+ kanıtlanmış smart-money cüzdanının on-chain swap'larını 7/24 izler.",
    how_step2_title: "Sinyali doğrularız",
    how_step2_body:
      "N cüzdan senin zaman aralığında aynı tokeni bağımsız olarak alırsa bot yapılandırılmış uyarı atar.",
    how_step3_title: "Sen işlem yaparsın ya da bot yapar",
    how_step3_body:
      "Kopyalamak için tıkla, ya da auto-mode'u aç; bot seçtiğin ETH büyüklüğüyle pozisyonu senin için açar.",
    how_full_link: "Detaylı anlatımı oku →",

    final_cta_title: "Hareketi kaçırmaya son vermeye hazır mısın?",
    final_cta_sub:
      "Botu aç, filtrelerini ayarla, ve smart money sana ne zaman harekete geçeceğini söylesin.",
    final_cta_button: "Telegram’da aç",
  },

  how: {
    // Hero
    live_badge: "Base, Ethereum, Solana, Robinhood, BNB & Arc'ta canlı",
    hero_title: "AlphaHedge nasıl kullanılır",
    hero_sub: "Önce sinyalleri ayarla, ardından isteğe bağlı otomatik işlemi keşfet. Aşağıdaki ürün ekranlarıyla adım adım ilerle.",

    // Progress bar
    prog_1: "Botu Aç",
    prog_2: "Sinyaller",
    prog_3: "Copy Trade",
    prog_4: "İnce Ayar",
    prog_5: "Hızlı Alım",
    prog_6: "Strateji Lab",
    prog_7: "İşleme Başla!",

    // Step 1 - Open Bot
    step1_tag: "Başlangıç",
    step1_title: "Telegram'da botu aç",
    step1_p1:
      "/start yaz (karşına ana kontrol paneli çıkacak). Sinyaller, cüzdanlar, pozisyonlar, copy trade... her şey bir dokunuş uzaklığında.",
    step1_p2:
      "Bot abonelik durumunu gösterir ve tüm özelliklere hızlı erişim sağlar.",
    pill_signals: "Sinyallerim",
    pill_copytrade: "Copy Trade",
    pill_wallets: "İşlem Cüzdanları",
    pill_positions: "Açık Pozisyonlar",

    // Step 2 - Signal Filters
    step2_tag: "Sinyalleri Ayarla",
    step2_title: "Sinyal filtrelerini belirle",
    step2_p1:
      "\"Sinyallerim\" butonuna bas ve hangi uyarıları alacağını kontrol et. Aktif zincirleri seç, minimum akıllı cüzdan konsensüsünü ayarla, alım/satım sinyallerini aç ya da kapat.",
    step2_p2:
      "MCAP aralığı, token yaş limitleri belirle, yüksek aktivite balina uyarılarını etkinleştir. Her sinyal profiline göre süzülerek sana ulaşır.",
    pill_chain: "Zincir Seçimi",
    pill_min_wallets: "Min Cüzdan: 3+",
    pill_mcap: "MCAP Aralığı",
    pill_age: "Yaş Limitleri",

    // Copy Trade divider
    copytrade_divider: "Copy Trade Stratejisi Oluştur",

    // Wizard section
    wizard_tag: "5 Hızlı Adım",
    wizard_title: "İlk işlem stratejini oluştur",
    wizard_sub: "Cüzdanını seç, filtrelerini ve işlem tutarını belirle. Fon yatırmadan ve otomatik işlemi açmadan önce ayarlarını gözden geçir.",
    wiz_solana_note:
      "Solana mı tercih edersin? Aynı mantık, kendine özel bir akışla: bir Solana cüzdanı seç, filtrelerini ayarla, bot senin için Jupiter üzerinden işlem yapsın. Zincir seçimi yok — tasarım gereği doğrudan Solana.",

    // Wizard cards
    wiz1_tag: "Seçim",
    wiz1_title: "Cüzdanını seç",
    wiz1_desc: "Stratejinin hangi işlem cüzdanından çalışacağını belirle.",
    wiz2_tag: "Adım 1/4",
    wiz2_title: "Min Akıllı Cüzdan",
    wiz2_desc: "Strateji tetiklenmeden önce kaç cüzdanın alması gerektiğini belirle (3–20).",
    wiz3_tag: "Adım 2/4",
    wiz3_title: "Zincir seç",
    wiz3_desc: "Base, Ethereum, Robinhood ve BNB Chain arasından seç. Kullanılabilir ayarlar seçtiğin zincire göre değişir.",
    wiz4_tag: "Adım 3/4",
    wiz4_title: "İşlem başına tutar",
    wiz4_desc: "Native token tutarını belirle: Base, Ethereum ve Robinhood için ETH; BNB Chain için BNB.",
    wiz5_tag: "Adım 4/4",
    wiz5_title: "İsim ver",
    wiz5_desc: "Stratejini tanımlamak için bir isim seç (en fazla 64 karakter).",

    // Result
    result_tag: "Tamam!",
    result_title: "Stratejin artık aktif",
    result_sub:
      "Oluşturulan strateji anında sinyalleri kopyalamaya başlar. Her detayı ayarlar panelinden ince ayar yapabilirsin.",

    // Duo showcase
    step6_tag: "Adım 6",
    step6_title: "Strateji oluşturuldu ve aktif",
    step6_desc:
      "Stratejin anında aktif olur. Bot eşleşen sinyalleri cüzdanına kopyalamaya başlar (istediğin zaman durdur veya devam ettir).",
    step7_tag: "Adım 7",
    step7_title: "Detaylı strateji ayarları",
    step7_desc:
      "Tetikleme filtreleri, alım ayarları, satış TP/SL, sinyal kaynakları, gas ve slippage: her parametre üzerinde tam kontrol.",

    // Bonus divider
    bonus_divider: "Bonus Özellik",

    // Quick Buy
    qb_tag: "Hızlı Alım",
    qb_title: "Sinyalden doğrudan işlem yap",
    qb_p1: "Hızlı Alım için en fazla 4 hazır tutar belirle. Tek dokunuş, ayrı bir onay ekranı olmadan swap isteğini gönderir. Önce cüzdan, zincir ve tutarı kontrol et.",
    qb_p2: "Slippage ve gas limitlerini ayarla, varsayılan cüzdanını seç. Desteklenen ve yapılandırılmış zincirlerde özel işlem gönderimi kullanılabilir; MEV riskini tamamen ortadan kaldırmaz.",
    qb_pill1: "Tek Dokunuş",
    qb_pill2: "4 Hazır Tutar",
    qb_pill3: "MEV Koruma",
    qb_pill4: "Özel Gas",

    // Strategy Lab
    lab_divider: "Strateji Lab",
    lab_tag: "Strateji Lab",
    lab_title: "Yayına almadan önce backtest et",
    lab_p1:
      "Son 90 günün gerçek sinyalleri üzerinde what-if simülasyonu çalıştır. Min akıllı cüzdan, MCAP aralığı, token yaşı, zincir filtrelerini ayarla ve PnL, kazanç oranı, medyan çarpan ve dağılımı anında gör.",
    lab_p2: "Varsayımsal zirve bazlı çıkış modelini günlük HODL fiyat görüntüsüyle karşılaştır. Bu modeller geçmiş sinyalleri gösterir; gerçekleşmiş işlem veya gelecekteki getiri değildir.",
    lab_pill1: "90 Gün Backtest",
    lab_pill2: "What-If PnL",
    lab_pill3: "Çarpan Dağılımı",
    lab_pill4: "HODL Reality Check",
    lab_cta: "Strateji Lab'ı Aç",

    // Token Protection
    shield_divider: "Token Koruma",
    shield_tag: "Çok Katmanlı Güvenlik",
    shield_title: "Sınırları açık risk kontrolleri",
    shield_sub: "Mevcut kontroller kontrat ve işlem risklerini işaretler. Kapsam zincire ve sağlayıcıya göre değişir; başarılı tarama, işlemin güvenli veya kârlı olacağını garanti etmez.",

    shield_how_title: "Nasıl çalışır",
    shield_how_p1: "Base, Ethereum ve BNB Chain için GoPlus Security ve honeypot.is; Solana için RugCheck kullanılır. Bu sağlayıcılar Robinhood ve Arc için aynı kapsamı sunmaz.",
    shield_how_p2: "Sonuçlar 5 dakika önbellekte tutulur. Kontrol kullanılamazsa veya başarısız olursa bazı işlem yolları tamamlanmış bir değerlendirme olmadan devam edebilir. Sonuç alınamaması tokenin güvenli olduğunu göstermez.",

    shield_levels_title: "Risk seviyeleri",
    shield_critical_title: "Kritik: copy-trade engellenir",
    shield_critical_desc: "Kritik değerlendirme copy-trade işlemini engeller ve Telegram bildirimi oluşturur. Bu işaretler ciddi risk gösterir; kapsamlı bir güvenlik denetimi değildir.",
    shield_critical_1: "Honeypot tespit edildi (al→sat simülasyonu başarısız)",
    shield_critical_2: "Satış vergisi %30'u aşıyor",
    shield_critical_3: "Token statik analiz tarafından honeypot olarak işaretlendi",
    shield_critical_4: "Token tamamen satılamıyor",

    shield_high_title: "Yüksek: varsayılan olarak atlanır",
    shield_high_desc: "Sinyal uyarı afişiyle iletilir. Strateji ayarlarında 'Riskli Tokenlere İzin Ver'i açmadığın sürece copy-trade atlanır.",
    shield_high_1: "Sahip vergi oranlarını istediği zaman değiştirebilir",
    shield_high_2: "Cüzdan bazlı özel vergi uygulanabilir",
    shield_high_3: "Gizli kontrat sahipliği",
    shield_high_4: "1 veya daha az token sahibi",
    shield_high_5: "Oluşturucu arzın %90'ından fazlasını elinde tutuyor",

    shield_clean_title: "İşaretlenen sorun yok",
    shield_clean_desc: "Mevcut kontroller engelleyici sorun bulmadı. Diğer işlem kuralları geçerliliğini korur. Bu sonuç güvenlik, likidite veya başarılı çıkış garantisi değildir.",

    shield_extra_title: "Ek güvenlik önlemleri",
    shield_extra_1_title: "Devre Kesici",
    shield_extra_1_desc: "Bir token tekrar eden işlem hatalarına sebep olursa, tüm kullanıcılar için otomatik olarak 1 saatliğine engellenir.",
    shield_extra_2_title: "Fiyat Tutarlılık Kontrolü",
    shield_extra_2_desc: "Her alımdan önce bot, DEX kotasyonunu piyasa fiyatıyla karşılaştırır. Aşırı sapmalar (likit olmayan havuzlar, bayat fiyatlar) reddedilir.",
    shield_extra_3_title: "Likidite Tabanı",
    shield_extra_3_desc: "Ayarlanan likidite eşikleri sığ havuzları elemek için kullanılabilir. Satışın gerçekleşeceğini garanti etmez veya tüm slippage riskini ortadan kaldırmaz.",
    shield_extra_4_title: "MEV Koruması",
    shield_extra_4_desc: "Desteklenen ve yapılandırılmış zincirlerde özel işlem gönderimi public mempool görünürlüğünü azaltabilir. Aktarım başarısız olursa normal gönderime dönülebilir.",

    shield_info_title: "Bilgilendirme bayrakları",
    shield_info_desc: "Bunlar şeffaflık için sinyal mesajlarında görünür ama işlemleri engellemez. Meşru tokenlerde de yaygındır.",
    shield_info_1: "Transfer duraklatılabilir (OpenZeppelin standardı)",
    shield_info_2: "Kara liste fonksiyonu mevcut (USDC/USDT'de de var)",
    shield_info_3: "Token mint edilebilir",
    shield_info_4: "İşlem bekleme süresi aktif",

    // FAQ
    faq_title: "SSS",
    faq_sub: "Cüzdan bağlamadan önce herkesin sorduğu sorular.",
    faq_q1: "Bota private key'lerimi vermem gerekiyor mu?",
    faq_a1: "Sadece sinyal almak için cüzdan veya private key gerekmez. Otomatik işlemde bot, işlem cüzdanının private key’ini şifreli saklar ve işlemleri imzalamak için çözer. Yalnızca işlem yapmak istediğin tutarla fonladığın ayrı bir cüzdan kullan.",
    faq_q2: "Hangi zincirler destekleniyor?",
    faq_a2:
      "Base, Ethereum, Solana, Robinhood, BNB Chain ve Arc. Hepsi eşzamanlı izleniyor ve sinyaller zincire göre etiketleniyor. Otomatik copy-trade Base, Ethereum, Robinhood, BNB Chain & Solana'da çalışıyor. Arc şimdilik sadece sinyal veriyor.",
    faq_q3: "Buradaki 'akıllı cüzdan' ne anlama geliyor?",
    faq_a3:
      "Kanıtlanabilir şekilde kazananları seçmiş cüzdanlar. Cüzdanları kâğıt üstündeki değil, gerçekleşen çıkışlardan elde edilen PnL'e göre puanlıyoruz. Eşik altına düşen cüzdanlar rotasyondan çıkıyor.",
    faq_q4: "Kaydolmadan geçmiş performansı görebilir miyim?",
    faq_a4_lead: "Evet, ",
    faq_a4_link: "Stratejiler",
    faq_a4_tail:
      " sayfasını ziyaret et. Son 30 günün gerçek sinyallerinden en iyi filtre kombinasyonlarını gösterir, günlük yenilenir.",
    faq_q5: "Backtest çarpan sınırı ne anlama gelir?",
    faq_a5: "Model, uç değerlerin etkisini azaltmak için her varsayımsal çıkış çarpanını 10× ile sınırlar. Bu sınır likidite, slippage veya gerçek işlem yürütme simülasyonu değildir. Geçmiş zirveler ve model PnL’si, gerçekleşmiş işlem getirisi sayılmaz.",

    bottom_cta_title: "Kendi gözünle gör",
    bottom_cta_sub: "Botu Telegram'da aç; ilk sinyaller ücretsiz.",
    bottom_cta_button: "Telegram’da aç",
  },

  lab: {
    page_label: "Geçmiş simülasyon",
    page_title: "Strateji Lab",
    page_sub: "90 güne kadar geçmiş sinyalleri incele. Günlük fiyat görüntüsünü varsayımsal zirve bazlı çıkışlarla karşılaştır. Sonuçlar simülasyondur; gerçekleşmiş işlem değildir. İzlenen cüzdanların kimlikleri gizli kalır.",

    error_rate_limit:
      "Rate limit'e ulaşıldı. Filtreleri tekrar oynamadan önce biraz bekle.",
    error_backtest_failed: "Backtest başarısız: {msg}",

    whatif_header: "Modellenmiş çıkış sonuçları",
    running: "çalışıyor…",

    top_title: "Geçmişte öne çıkan {n} strateji",
    top_sub: "Son {days} günün model PnL’sine göre sıralanan {n} filtre kombinasyonu. Senin filtrelerinden bağımsız, günlük yenilenir. Sıralama geçmiş verilere dayanır ve gelecekteki getiriyi öngörmez.",
    top_last_updated: "Son güncelleme:",
    top_snapshot_generating: "Snapshot oluşturuluyor. Birazdan yenile.",
    top_load_error: "Yüklenemedi: {msg}",
    top_loading: "Stratejiler yükleniyor…",
    top_empty: "Snapshot boş. Bir sonraki günlük yenilemeden sonra kontrol et.",

    col_filter: "Filtre",
    col_signals: "Sinyal",
    col_median: "Medyan ×",
    col_win_rate: "Kazanç oranı",
    col_2x5x: "2× / 5×",
    col_pnl: "Model PnL ($)",

    cta_title: "Bu sinyalleri gerçekten kullanmak ister misin?",
    cta_sub:
      "Botu Telegram'da aç, filtreni uygula ve gerçek zamanlı uyarı almaya başla.",
    cta_button: "Telegram’da aç",
  },

  filter: {
    header: "Filtreler",
    reset: "Sıfırla",
    lookback_days: "Geçmiş (gün)",
    min_smart_wallets: "Min akıllı cüzdan",
    min_entry_mc: "Min giriş MC (USD)",
    max_entry_mc: "Max giriş MC (USD)",
    max_peak_mc: "Max peak MC (USD) (uç değer cap'i)",
    min_liquidity: "Min likidite (USD)",
    max_liquidity: "Max likidite (USD)",
    max_token_age: "Sinyal anında max token yaşı",
    chains_label: "Zincirler:",
    exit_model: "Varsayımsal çıkış modeli",
    exit_at_peak: "Peak'in %'inde çık",
    per_trade_size: "İşlem başına ($)",
    suffix_min: "dk",
    quality_label: "Sinyal kalitesi:",
    quality_neutral: "Nötr",
    quality_hint:
      "Bottaki her sinyalin taşıdığı ★ puanı; sinyal anındaki token yaşı ve likiditeye göre belirlenir.",
  },

  results: {
    model_note: "Kaydedilen zirvenin seçilen oranında varsayımsal çıkış. Çıkış çarpanı sınırı: {cap}. Modeldeki çıkış ücreti: %{fee}. Gas, slippage, likidite ve işlem gecikmeleri modellenmez.",
    no_cap: "Sınırsız",
    empty_state: "Backtest çalıştırmak için filtreleri ayarla.",
    signals: "Sinyaller",
    win_loss: "{w} kazanç / {l} kayıp",
    win_rate: "Kazanç oranı",
    win_rate_hint: "2×: {p2}% / 5×: {p5}% / 10×: {p10}%",
    median_multiplier: "Medyan çarpan",
    median_hint: "ort {avg}× (uç değer etkili)",
    exit_label: "%{pct} peak'te çık",
    exit_hint: "yatırılan ${inv} · ROI {sign}{roi}%",
    pnl_chart_title: "Kümülatif model PnL",
    no_signals: "uygun sinyal yok",
    hit_chart_title: "Zirve çarpanı dağılımı",
    hit_chart_disclaimer_line1: "Kaydedilmiş geçmiş zirveler.",
    hit_chart_disclaimer_line2: "Gerçekleşmiş işlem getirisi değildir.",
  },

  hodl: {
    title: "HODL fiyat görüntüsü",
    sub_lead: "Geçmişe dayalı model: her eşleşen sinyalden alıp ",
    sub_strong: "fiyat görüntüsü alınana kadar tutmak",
    sub_tail: ". DexScreener fiyatları günlük yenileme sırasında alınır. Giriş fiyatının altına düşüşler 1× altında görünür. Canlı portföy veya gerçekleşmiş getiri değildir.",
    updated: "Güncellendi:",
    slider_label: "Min akıllı cüzdan",
    days_label: "Pencere",
    quality_label: "Kalite",
    loading_inline: "yükleniyor…",
    snapshot_generating: "HODL snapshot oluşturuluyor. Birazdan yenile.",
    load_error: "Yüklenemedi: {msg}",
    loading: "HODL snapshot yükleniyor…",
    empty_at_threshold:
      "Son {days} günde {n}+ akıllı cüzdan ve seçili kaliteyle eşleşen token yok. Başka filtre dene.",
    stat_tokens_with_price: "Token (fiyatı olan)",
    stat_tokens_with_price_hint_missing: "{n} eksik fiyat hesap dışında",
    stat_tokens_with_price_hint_all: "tüm tokenler için fiyat mevcut",
    stat_win_rate: "Kazanç oranı (>1×)",
    stat_win_rate_hint: "{w} yukarı / {l} aşağı",
    stat_median: "Medyan çarpan",
    stat_median_hint: "görüntüdeki MC ÷ giriş MC",
    stat_pnl: "Model PnL",
    stat_pnl_hint: "yatırılan ${inv}",
    description: "Sinyal başına ${size}. Fiyatı alınamayan tokenler sıfır sayılmaz; PnL, kazanç oranı ve dağılım hesabı dışında tutulur. Gas, slippage ve işlem sınırları modellenmez.",
    distribution_title: "HODL çarpan dağılımı",
  },

  tokens: {
    page_label: "Sinyal geçmişi",
    page_title: "Seçili runner’lar",
    page_sub: "24 saat gecikmeyle geçmiş runner örnekleri. Yalnızca kayıtlı zirve oranı en az 1,5× olan sinyaller seçilir. Birleştirilen bu değerler tüm performansı veya gerçekleştirilebilir işlem getirisini göstermez.",
    chain_label: "Zincir",
    chain_all: "Tümü",
    sort_label: "Sırala",
    sort_top: "En yüksek zirve oranı",
    sort_recent: "En yeni",
    window_label: "Pencere",
    window_all: "Tümü",
    wallets_label: "Min cüzdan",
    loading_inline: "yükleniyor…",
    error_rate_limit: "Rate limit'e ulaşıldı. Biraz bekle.",
    error_generic: "Yüklenemedi: {msg}",
    loading: "Tokenler yükleniyor…",
    empty_title: "Seçime uyan runner bulunamadı",
    empty_sub: "Daha uzun bir dönem, daha düşük minimum cüzdan sayısı veya tüm zincirleri dene.",
    col_token: "Token",
    col_chain: "Zincir",
    col_mc_signal: "Min sinyal MC",
    col_peak_mc: "Max zirve MC",
    col_peak_mult: "Zirve oranı",
    col_age: "Kayıt yaşı",
    age_today: "bugün",
    age_one_day: "1g önce",
    age_n_days: "{n}g önce",
    footnote: "{count} seçili runner gösteriliyor · {days} günlük dönem · 24 saat gecikme",
    footnote_all: "{count} seçili runner gösteriliyor · mevcut geçmiş · 24 saat gecikme",
    pagination_prev: "‹ Önceki",
    pagination_next: "Sonraki ›",
    pagination_page: "sayfa {n}",
    cta_title: "Yeni sinyalleri Telegram’da takip et",
    cta_sub: "Token detaylarını gör, filtrelerini seç ve desteklenen zincirlerde isteğe bağlı otomatik işlemi keşfet.",
    cta_button: "Telegram’da aç",
    methodology_note: "Zirve oranı = seçilen kayıtlarda tokenin en yüksek kayıtlı zirve piyasa değeri ÷ en düşük uygun sinyal piyasa değeri. İki değer farklı sinyallerden gelebilir; sıraları önce alım sonra satış getirisi oluşturduğunu göstermez. Kayıt sınırları, likidite ve sert fiyat düşüşü filtreleri bazı tokenleri seçimin dışında bırakabilir.",
  },

  misc: {
    just_now: "az önce",
    min_ago: "{n} dk önce",
    hr_ago: "{n} sa önce",
    days_ago: "{n} gün önce",
    unknown: "bilinmiyor",
    retry: "Tekrar dene",
  },
};

export default tr;
